module.exports = __webpack_public_path__ + "02_face.66a0a85d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer1/02_face.png
// module id = Tbq6
// module chunks = 0